<script>
	import { isInlineIcon, isSuit, isTrait } from '../types';
	import SuitChip from '../chips/SuitChip.svelte';
	import TraitChip from '../chips/TraitChip.svelte';
	import { getNewIcon } from '../../card_images';
	import { replaceTextShortcuts } from './helpers';
	import "../shared.css";

	export let text;
	export let color;
	export let size = 14;

	// size was 10
	// now we need it as a calculation relative to height (401)

	function getSize(s){
		return `calc(var(--height) / ${401 / s})`
	}

	$: textParts = text.split(/\[\[([\w-?' ]+)\]\]/g);
</script>

<span
	class="op-text font-body"
	style="--font-color:{color};--font-size:{getSize(size)}; --svg-size:{getSize(size + 3)};"
>
<!--style="--font-color:{color};--font-size:{{size}px};--svg-size:{size + 4}px"-->
	{#each textParts as part}
		{#if isSuit(part)}
			<SuitChip suit={part} />
		{:else if isTrait(part)}
			<TraitChip trait={part} />
		{:else if isInlineIcon(part)}
			<img src={getNewIcon(part)} />
		{:else}
			{@html replaceTextShortcuts(part)}
		{/if}
	{/each}
</span>

<style>
	.op-text {
		font-size: var(--font-size);
		font-weight: 500;
		color: var(--font-color);
	}
	.op-text > :global(img) {
		width: var(--svg-size);
		height: var(--svg-size);
		margin-bottom: -0.25em;
	}
	:global(.mission) .op-text {
		font-size: calc(var(--height) / 28.643); /* 14px; */
	}
</style>
